import { LearningRecommendationsService } from '@/services/learningRecommendation'
import {
  ApiErrorResponse,
  ApiIndividualResponse,
  ApiReactMutationOptions,
} from '@/types/api'
import { IRecommendation } from '@/types/recommendations'
import { useMutation, useQueryClient } from '@tanstack/react-query'

type UseCreateLearningRecommendationOptions = {
  mutationOptions?: ApiReactMutationOptions<
    ApiIndividualResponse<IRecommendation>,
    void
  >
}

export const useCreateLearningRecommendation = ({
  mutationOptions,
}: UseCreateLearningRecommendationOptions = {}) => {
  const queryClient = useQueryClient()

  return useMutation<
    ApiIndividualResponse<IRecommendation>,
    ApiErrorResponse,
    void
  >({
    ...mutationOptions,
    mutationKey: ['learning-recommendations', 'create'],
    mutationFn: () =>
      LearningRecommendationsService.createLearningRecommendation(),
    onSuccess: async (...args) => {
      queryClient.invalidateQueries({
        queryKey: ['learning-recommendations'],
        exact: false,
      })
      await mutationOptions?.onSuccess?.(...args)
    },
  })
}
